<template>
  <div class="contactInformation p-4 text-left">
    <div class="py-3">
      <p class="text-xl font-medium py-2">
        NEXT DEDUCTION
      </p>
      <!-- <template v-if="previousDeduction">
									<div class="pb-4">
									<p class="text-white font-bold py-1">{{dateTime(previousDeduction.PayPeriodDate)}}
									</p>
									<template v-if="previousDeduction.DeductionMain">
										<div class="py-1">
										<p>WinWin Staff Lottery</p>
										<p class="text-white">{{getMainTicketPackageByValue(previousDeduction.DeductionMain)}}</p>
										<p class="text-right font-bold">${{previousDeduction.DeductionMain}}</p>
										</div>
									</template>
									<template v-if="previousDeduction.Deduction5050">
										<div class="py-1">
										<p>Quarterly Cash 50/50</p>
										<p class="text-white">{{get5050TicketPackageByValue(previousDeduction.Deduction5050)}}</p>
										<p class="text-right font-bold">${{previousDeduction.Deduction5050}}</p>
										</div>
									</template>
									</div>
								</template> -->

		<p class="font-bold">
          {{ dateTime(nextDeductionCalculation()) }}
        </p>
	<!--
      <template v-if="nextPayPeriod">
        <p class="font-bold">
          {{ dateTime(nextPayPeriod.PayPeriodDate) }}
        </p>
        
      </template>
	-->
    </div>
  </div>
</template>

<script>
import moment from "moment";
    export default {
        name: "UpcomingDeduction",
        props: ["nextPayPeriod"],
        methods: {
            dateTime(value) {
				// format Date object to readable format
				return moment(value).format("MMMM Do, YYYY");
			},
			nextDeductionCalculation(){
				let currentTime = moment();
				//let currentTime = moment("12-25-2024", "MM-DD-YYYY");
				const firstDeduction = moment("01-07-2026", "MM-DD-YYYY");
				const lastDeduction = moment("12-23-2026", "MM-DD-YYYY");
				let daysSinceFirstDeduction = currentTime.diff(firstDeduction, 'days');
				let quotient, remainder, result, daysSinceLastDeduction;

				quotient = Math.floor(daysSinceFirstDeduction/14);
				remainder = daysSinceFirstDeduction%14;
				if (daysSinceFirstDeduction<0){
					result = firstDeduction;
				}
				else{
					if (remainder == 0){
						result = moment(firstDeduction);
						result.add(14*quotient,'days');
					}
					else{
						result = moment(firstDeduction);
						result.add(14*(quotient+1),'days');
					}
				}

				daysSinceLastDeduction = result.diff(lastDeduction, 'days');

				if (daysSinceLastDeduction>0){
					result = lastDeduction;
				}

				return result;
			},
        }
    }
</script>

<style lang="scss" scoped>

</style>